import LeadsUser from "./LeadsUser";

export default LeadsUser;
